export default __webpack_public_path__ + "static/media/sidebar-3.c1f75b88.jpg";